<template>
  <div>
  </div>
</template>
<script>
  export default {
    name: '',
    data () {
      return {
      }
    },
    created () {
      location.href = './home.html'
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?43542912